const allProducts = UD_VUE.createApp({
  data() {
    return {
      total_products: window.all_product_count,
      selected_type: window.selected_type,
      product_types: [
        { type: "cooking", options: ["range", "cooktop", "wall-oven", "microwave", "hood", "discontinued-cooking"] },
        {
          type: "refrigerators",
          options: ["built-in-refrigerator", "freestanding-refrigerator", "discontinued-refrigerator"],
        },
        {
          type: "dishwashers",
          options: ["top-control-dishwasher", "front-control-dishwasher", "discontinued-dishwasher"],
        },
        {
          type: "laundry",
          options: ["dryer", "front-load-washing-machine", "combo-washer-dryer", "discontinued-laundry"],
        },
      ],
      all_products: [],
      sortBy: "alphabetically",
      filter_options: [],
      filter_options_json: [],
      current_filter_options: [],
      current_filter_options_json: [],
      checked_values: [],
      checked_values_json: [],
      brochure: [],
      specific_filter_options: [],
      specific_filter_options_json: [],
    };
  },

  created() {
    this.getProducts();
  },

  mouted() {},

  computed: {
    filteredProducts() {
      let tempProducts = this.all_products;
      tempProducts = tempProducts.filter(this.findProducts);

      // console.log("temp products 1: ", tempProducts);

      if (this.checked_values.length > 0) {
        tempProducts = tempProducts.filter(this.findValue);
      } else {
        //         this.checked_values.push({"option": 'type', "values": ['all']})
        this.getSpecificFilterOptions();
      }

      // console.log("temp products 2: ", tempProducts);

      tempProducts = tempProducts.sort((a, b) => {
        if (this.sortBy == "alphabetically") {
          let fa = a.title.toLowerCase(),
            fb = b.title.toLowerCase();
          if (fa < fb) return -1;
          if (fa > fb) return 1;
          return 0;
        } else if (this.sortBy == "reverse-alphabetically") {
          let fa = a.title.toLowerCase(),
            fb = b.title.toLowerCase();
          if (fa < fb) return 1;
          if (fa > fb) return -1;
          return 0;
        } else if (this.sortBy == "highestPrice") {
          return b.variants[0].price - a.variants[0].price;
        } else if (this.sortBy == "lowestPrice") {
          return a.variants[0].price - b.variants[0].price;
        }
      });

      return tempProducts;
    },

    filteredProductsCad() {
      let tempProducts = this.all_products;
      tempProducts = tempProducts.filter(this.findProducts);

      if (this.checked_values.length > 0) {
        tempProducts = tempProducts.filter(this.findValue);
      }

      // console.log("temp products 1: ", tempProducts);

      tempProducts = tempProducts.filter(this.findCad);

      // console.log("temp products 2: ", tempProducts);

      tempProducts = tempProducts.sort((a, b) => {
        if (this.sortBy == "alphabetically") {
          let fa = a.title.toLowerCase(),
            fb = b.title.toLowerCase();
          if (fa < fb) return -1;
          if (fa > fb) return 1;
          return 0;
        } else if (this.sortBy == "reverse-alphabetically") {
          let fa = a.title.toLowerCase(),
            fb = b.title.toLowerCase();
          if (fa < fb) return 1;
          if (fa > fb) return -1;
          return 0;
        } else if (this.sortBy == "highestPrice") {
          return b.variants[0].price - a.variants[0].price;
        } else if (this.sortBy == "lowestPrice") {
          return a.variants[0].price - b.variants[0].price;
        }
      });

      return tempProducts;
    },

    currentSubType() {
      let current_type = this.checked_values.find((x) => x["option"] == "type");
      if (current_type) {
        return current_type["values"][0];
      } else {
        console.log("UD ERROR: could not get current type");
      }
      this.getSpecificFilterOptions();
      return "null";
    },
  },

  methods: {
    getImage(handle) {
      // console.log("GETTING IMAGE FOR PRODUCT with handle: ", handle)
      let product = this.all_products.find((x) => x.handle == handle);
      // console.log("GETTING IMAGE FOR PRODUCT: ", product)
      if (product) {
        return product.images[0].src;
      } else {
        return null;
      }
    },

    getTitle(handle) {
      let product = this.all_products.find((x) => x.handle == handle);
      // console.log("GETTING TITLE FOR PRODUCT: ", product)
      if (product) {
        return product.title;
      } else {
        return null;
      }
    },

    getSku(handle) {
      let product = this.all_products.find((x) => x.handle == handle);
      // console.log("GETTING SKU FOR PRODUCT: ", product)
      if (product) {
        return product.variants[0].sku;
      } else {
        return null;
      }
    },

    addCompare(handle) {
      let brochure = this.brochure;
      if (!brochure) {
        brochure = [];
      } else {
        brochure = brochure.split(",");
      }
      let key_found = brochure.find((x) => x == handle);
      if (key_found) {
        let idx = brochure.indexOf(handle);
        brochure.splice(idx, 1);
      } else {
        brochure.push(handle);
        $(".brochure").scrollLeft(1000000);
      }
      this.brochure = brochure;
    },

    isCompared(handle) {
      let brochure = this.brochure;
      if (!brochure) {
        brochure = [];
      } else {
        brochure = brochure.split(",");
      }
      let found = brochure.find((x) => x == handle);
      if (found) {
        // console.log("found handle: ", handle)
        return true;
      }
      return false;
    },

    comparedExists() {
      let brochure = this.brochure;
      if (!brochure) {
        brochure = [];
      } else {
        brochure = brochure.split(",");
      }
      let found = this.all_products.find((x) => x == brochure[0]);
      if (!found) {
        this.brochure = [];
      }
    },

    clearCompare() {
      this.brochure = [];
    },

    filterByValue(value) {
      // console.log("GET PRODUCTS BY VALUE: ", value);

      value = value.toLowerCase();
      let tempProducts = this.all_products;
      tempProducts = tempProducts.filter(
        (product) =>
          product.title.toLowerCase().includes(value) ||
          product.handle.includes(value) ||
          product.variants[0].sku.toLowerCase().includes(value)
      );
      return tempProducts;
    },

    filterByValueCad(value) {
      // console.log("GET PRODUCTS BY VALUE: ", value);

      value = value.toLowerCase();
      let tempProducts = this.all_products;

      tempProducts = tempProducts.filter(this.findCad);

      tempProducts = tempProducts.filter(
        (product) =>
          product.title.toLowerCase().includes(value) ||
          product.handle.includes(value) ||
          product.variants[0].sku.toLowerCase().includes(value)
      );
      return tempProducts;
    },

    url(product) {
      return "/products/" + product.handle;
    },

    specificationsUrl(product) {
      return "https://blomberg.s3.amazonaws.com/specifications-library/" + product.variants[0].sku + "_spec-sheet.pdf";
    },

    sendDataLayer(product, fileType, document) {
      // console.log("file tyle", fileType)
      window.dataLayer.push({
        event: "downloadFile",
        fileType: fileType,
        forProduct: product.handle,
        documentType: document,
      });
    },

    inBrochure(product) {
      let found = this.brochure.find((x) => x == product);
      if (found) return true;
      return false;
    },

    addToBrochure(product) {
      let found = this.brochure.find((x) => x == product);
      found ? this.brochure.splice(this.brochure.indexOf(found), 1) : this.brochure.push(product);
    },

    getBrochure() {
      //this is where we need to make a request to the API with all of the selected SKUs, and then run
      //the pdf-merger Node extension to merge the PDFs and serve back to the client

      //       GTM
      window.dataLayer.push({ event: "downloadFile", fileType: "pdf", forProduct: "brochure-maker" });

      // console.log("this.brochure: ", this.brochure)

      let skus = [];
      for (let i = 0; i < this.brochure.length; i++) {
        let product = this.brochure[i];
        // console.log("product: ", product)
        // console.log("variants: ", product.variants)

        skus.push(product.variants[0].sku);
      }

      let data = {
        skus: skus,
      };

      $.ajax({
        type: "GET",
        url: "http://shopify.udundi.io/api/generate-brochure",
        encoding: null,
        data: data,
      })
        .then(function (res) {
          // console.log("SUCCESS got pdf");

          let link = document.createElement("a");
          link.setAttribute("href", "data:application/pdf;base64," + res.toString("base64"));
          //link.setAttribute('target', '_blank');
          link.setAttribute("download", "Blomberg_Product_Brochure.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .fail(function (err) {
          console.log("ERROR: ", err);
        });
    },

    findProducts(product) {
      let accepted_types = this.product_types.find((x) => x["type"] == this.selected_type);
      if (accepted_types["options"].includes(product["type"])) return true;
      return false;
    },

    findProductsType(product, product_type) {
      let accepted_types = this.product_types.find((x) => x["type"] == product_type);
      if (accepted_types["options"].includes(product["type"])) return true;
      return false;
    },

    findValue(product) {
      var found = true;
      for (let i = 0; i < this.checked_values.length; i++) {
        var option = this.checked_values[i].option;
        var values = this.checked_values[i].values;
        var p_value = product[option];
        if (!this.checked_values[i].values.includes(p_value)) {
          found = false;
        }
      }
      return found;
    },

    findCad(product) {
      var found = true;
      if (!product.tags.includes("cad_RFA")) {
        found = false;
      }
      return found;
    },

    filteredProductsCadByType(product_type) {
      const vm = this;

      product_types = vm.product_types;

      let tempProducts = this.all_products;
      tempProducts = tempProducts.filter(function (product) {
        if (product["type"] == product_type) return true;
        else return false;
      });

      // console.log("temp products 1: ", tempProducts);

      tempProducts = tempProducts.filter(this.findCad);

      // console.log("temp products 2: ", tempProducts);

      if (tempProducts.length > 0) return true;
      else return false;
    },

    checkValue(option, value) {
      var key_found = this.checked_values.find((x) => x["option"] == option);
      if (key_found) {
        //this means the option name is in the list, check if the value is in the list
        var index = this.checked_values.indexOf(key_found);
        var value_found = this.checked_values[index]["values"].find((x) => x == value);
        if (!value_found) {
          //value is not in the list; add it to the list
          this.checked_values[index]["values"].push(value);
        } else {
          //value is in the list; remove it from the list
          var idx = this.checked_values[index]["values"].indexOf(value_found);
          this.checked_values[index]["values"].splice(idx, 1);
        }
        //if the option is now blank, remove it from the list
        if (this.checked_values[index]["values"].length == 0) {
          this.checked_values.splice(index, 1);
        }
      } else {
        //option name was not in the list, add it to the list with the selected value
        this.checked_values.push({ option: option, values: [value] });
      }
    },

    setSubType(value) {
      var key_found = this.checked_values.find((x) => x["option"] == "type");
      if (key_found) {
        var index = this.checked_values.indexOf(key_found);
        this.checked_values[index]["values"] = [value];
      } else {
        this.checked_values.push({ option: "type", values: [value] });
      }

      this.specific_filter_options = [];
      this.specific_filter_options_json = [];
      this.getSpecificFilterOptions();
    },

    getProducts(page = 1) {
      const vm = this;
      var hasPage = false;
      if (page <= 1) {
        this.all_products = [];
      } else if (page > 1) {
        hasPage = true;
      }
      url = "/collections/All/products.json";
      if (hasPage) {
        url += "?page=" + page;
        //url += '&page=' + page;
      }
      $.ajax({
        url: url,
        type: "GET",
      })
        .done(function (data) {
          if (data.length > 0) {
            vm.total_products = data[0].total;
          }
          vm.all_products = vm.all_products.concat(data.products);
          if (vm.all_products.length < vm.total_products) {
            page += 1;
            vm.getProducts(page);
          } else {
            // console.log("ALL PRODUCTS: ", vm.all_products)
            vm.processProducts();
          }
        })
        .fail(function (data) {
          console.log("error (likely too many requests): ", data);
          console.log("ALL PRODUCTS: ", vm.all_products);
          vm.processProducts();
        });
    },

    // getMetafields(index) {
    //   const vm = this
    //   if (index < this.all_products.length) {
    //     let product = this.all_products[index]
    //     url = '/products/' + product.handle + '/metafields.json';
    //     $.ajax({
    //       url: url,
    //       type: 'GET'
    //     }).done(function (data) {
    //       console.log("GOT METAFIELD DATA: ", data)
    //       vm.all_products[index]['metafields'] = data
    //       index++
    //       vm.getMetafields(index)
    //     }).fail(function (data) {
    //       console.log('error getting metafields, (likely too many requests): ', data);
    //       //vm.processProducts();
    //     });

    //   } else {
    //     //done getting metafields
    //     console.log("DONE GETTING METAFIELDS")
    //   }
    // },

    changeType(value) {
      this.selected_type = value;
      this.current_filter_options = [];
      this.current_filter_options_json = [];
      this.checked_values = [];
      for (let i = 0; i < this.filteredProducts.length; i++) {
        this.getCurrentFilterOptions(i);
      }
      // console.log("UD CURRENT FILTER OPTIONS: ", this.current_filter_options, this.current_filter_options_json);
      var current_type = this.current_filter_options.find((x) => x["option"] == "type");
      if (current_type) {
        this.setSubType(current_type["values"][0]);
      } else {
        console.log("error: could not get current type");
      }
    },

    processProducts() {
      for (let i = 0; i < this.all_products.length; i++) {
        this.getFilterOptions(i);
      }
      for (let i = 0; i < this.filteredProducts.length; i++) {
        this.getCurrentFilterOptions(i);
      }
      // console.log("UD CURRENT FILTER OPTIONS: ", this.current_filter_options, this.current_filter_options_json);
      var current_type = this.current_filter_options.find((x) => x["option"] == "type");
      if (current_type) {
        this.setSubType(current_type["values"][0]);
      }

      //now, lets run a loop to get all metafields for each product maybe? is that too resource intensive?
      //this.getMetafields(0)
      this.getSpecificFilterOptions();
    },

    //same as get filter options, but we just want to get the values from this product specifically
    getCurrentFilterOptions(idx) {
      var product = this.filteredProducts[idx];
      var tags = product.tags;
      for (var i = 0; i < tags.length; i++) {
        var tag = tags[i];
        if (tag.substring(0, 9) == "udfilter_") {
          var option = tag.split("_")[1];
          var option_value = tag.split("_")[2];
          //this.all_products[idx][option] = option_value
          var found = this.current_filter_options.find((el) => el.option == option);
          if (found) {
            var index = this.current_filter_options.indexOf(found);
            var u = this.current_filter_options_json.find((el) => el.option == option);
            if (!u.values.hasOwnProperty(option_value)) {
              this.current_filter_options[index].values.push(option_value);
              //var index = this.filter_options_json.indexOf(u);
              this.current_filter_options_json[index].values[option_value] = 1;
            }
          } else {
            this.current_filter_options.push({ option: option, values: [option_value] });
            this.current_filter_options_json.push({ option: option, values: {} });
            this.current_filter_options_json[this.current_filter_options_json.length - 1].values[option_value] = 1;
          }
        }
      }
    },

    getSpecificFilterOptions(idx = 0) {
      let tempProducts = this.all_products.filter(this.findProducts);

      if (this.checked_values.length > 0) {
        tempProducts = tempProducts.filter(this.findTypeValue);
      }

      // console.log("temp products: ", tempProducts);

      if (tempProducts.length > 0) {
        var product = tempProducts[idx];

        // console.log("idx: ", idx);

        // console.log("product: ", product);

        var tags = product.tags;
        for (var i = 0; i < tags.length; i++) {
          var tag = tags[i];
          if (tag.substring(0, 9) == "udfilter_") {
            var option = tag.split("_")[1];
            var option_value = tag.split("_")[2];

            var found = this.specific_filter_options.find((el) => el.option == option);
            if (found) {
              var index = this.specific_filter_options.indexOf(found);
              var u = this.specific_filter_options_json.find((el) => el.option == option);
              if (!u.values.hasOwnProperty(option_value)) {
                this.specific_filter_options[index].values.push(option_value);
                this.specific_filter_options_json[index].values[option_value] = 1;
              }
            } else {
              this.specific_filter_options.push({ option: option, values: [option_value] });
              this.specific_filter_options_json.push({ option: option, values: {} });
              this.specific_filter_options_json[this.specific_filter_options_json.length - 1].values[option_value] = 1;
            }
          }
        }

        if (idx + 1 < tempProducts.length) {
          //console.log("tempProducts length: ", tempProducts.length)
          this.getSpecificFilterOptions(idx + 1);
        }
      }
    },

    getFilterOptions(idx) {
      var product = this.all_products[idx];
      var tags = product.tags;
      for (var i = 0; i < tags.length; i++) {
        var tag = tags[i];
        if (tag.substring(0, 9) == "udfilter_") {
          var option = tag.split("_")[1];
          var option_value = tag.split("_")[2];
          this.all_products[idx][option] = option_value;
          var found = this.filter_options.find((el) => el.option == option);
          if (found) {
            var index = this.filter_options.indexOf(found);
            var u = this.filter_options_json.find((el) => el.option == option);
            if (!u.values.hasOwnProperty(option_value)) {
              this.filter_options[index].values.push(option_value);
              //var index = this.filter_options_json.indexOf(u);
              this.filter_options_json[index].values[option_value] = 1;
            }
          } else {
            this.filter_options.push({ option: option, values: [option_value] });
            this.filter_options_json.push({ option: option, values: {} });
            this.filter_options_json[this.filter_options_json.length - 1].values[option_value] = 1;
          }
        }
      }
    },

    findTypeValue(product) {
      var found = true;
      for (let i = 0; i < this.checked_values.length; i++) {
        if (this.checked_values[i].option == "type") {
          var option = this.checked_values[i].option;
          var values = this.checked_values[i].values;
          var p_value = product[option];
          if (!this.checked_values[i].values.includes(p_value)) {
            found = false;
          }
          if (option == "type" && values[0] == "all") {
            found = true;
          }
        }
      }
      return found;
    },
  },
}).mount("#ud-all-products");
